import React, { useState } from "react";
import { Row } from "react-bootstrap";
import priceHistoryIcon from '../../../public/assets/images/pdp/priceHistory.svg';
import priceHistoryActive from '../../../public/assets/images/pdp/priceHistoryIconActive.svg';
import propertyTaxIcon from '../../../public/assets/images/pdp/propertyTax.svg';
import propertyTaxActive from '../../../public/assets/images/pdp/propertyTaxActive.svg';
import "./style/pdp.css";
import { trackButtonClick } from "@/utils/analytics";

const LocalInfo = ({ taxRecord, priceHistory, demographicInfo, propCategory, isForeclosure, propertyData, hidePriceHistory, hidePropertyTaxes }) => {
  const propertyId = String(propertyData?.propertyId || "");

  // CMS pdpLocalInfo stores property IDs under hidePriceHistory / hidePropertyTaxes nodes.
  // Check both keys and values to handle different Magnolia serialization formats.
  const isPropertyInCmsNode = (cmsNode, id) => {
    if (!cmsNode || typeof cmsNode !== 'object' || !id) return false;
    const keys = Object.keys(cmsNode);
    const values = Object.values(cmsNode).filter(v => typeof v === 'string');
    return keys.includes(id) || values.includes(id);
  };

  const shouldHidePriceHistory = isPropertyInCmsNode(hidePriceHistory, propertyId);
  const shouldHidePropertyTaxes = isPropertyInCmsNode(hidePropertyTaxes, propertyId);


  // If both tabs are hidden (and not COMMERCIAL with demographics), hide the entire section
  const hasDemographics = propCategory === "COMMERCIAL";
  if (shouldHidePriceHistory && shouldHidePropertyTaxes && !hasDemographics) {
    return null;
  }

  // Determine default selected tab based on visibility
  const getDefaultTab = () => {
    if (!shouldHidePropertyTaxes) return "propertyTax";
    if (!shouldHidePriceHistory) return "priceHistory";
    if (hasDemographics) return "demographics";
    return "propertyTax";
  };

  const [selectedTab, setSelectedTab] = useState(getDefaultTab());
  const renderPriceHistory = () => {
    return (
      <>
      {
        priceHistory?.length > 0 ?
           <><table className="table table-borderless">
              <thead>
                <tr className="table-light">
                  <th  scope="col">DATE</th>
                  <th  scope="col">EVENT</th>
                  <th  scope="col">PRICE</th>
                </tr>
              </thead>
              <tbody>
                {priceHistory?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row"> {item?.date}</th>
                      <td>sold</td>
                      <td>{item?.price}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table><span size={8} lh={12} color={"rgb(133,146,158)"}>
                Source: County (Public) Records
              </span></>
        :
        <div style={{height:100}}>
        <p className="pt20" tabIndex="0">Not Available</p>
        </div>
      }

      </>
    );
  };

  const renderTax = () => {
    return (
       <>
      {
       (taxRecord && Object.keys(taxRecord)?.length > 0) ?

        <><table className="table">
              <tbody>
                <tr className="pt20">
                  <th className=" localInfo-dark pt20" scope="row">Tax ({taxRecord?.year})</th>
                  <td className="localInfo-dark text-center pt20" > {taxRecord?.taxAmount}</td>
                </tr>{" "}
                <tr className="pt20">
                  <th className=" localInfo-light pt20" scope="row">Land</th>
                  <td className="localInfo-light text-center pt20">{taxRecord?.landAmount}</td>
                </tr>
                <tr className="pt20">
                  <th className=" localInfo-dark pt20" scope="row">Additions</th>
                  <td className="text-center localInfo-dark pt20">{taxRecord?.additionsAmount}</td>
                </tr>
                <tr className="pt20">
                  <th  className="localInfo-light pt20" scope="row">Total</th>
                  <td className="text-center localInfo-light pt20" colSpan="2">{taxRecord?.totalAmount}</td>
                </tr>
              </tbody>
            </table><span size={8} lh={12} color={"rgb(133,146,158)"}>
                Source: County (Public) Records
              </span></>


        :

         <div style={{height:100}}>
        <p className="pt20" tabIndex="0">Not Available</p>
        </div>


      }
      </>
    )
  };

  return (
    <>
      <div className="propertyInfoBox mb30 tour-pdp-details">
        <Row className="propertyInfoBoxHeading p0">
          <h3 className='propertyInfoBoxHeadingText' tabIndex="0">Local Info</h3>
        </Row>
        <ul className="nav nav-tabs pb0 localInfoHeader" id="myTab" role="tablist">

            {!shouldHidePropertyTaxes && (
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link localInfoBtn ${selectedTab === 'propertyTax' ? 'active' : ''}`}
                data-bs-toggle="tab"
                href="#propertyTax"
                role="tab"
                onClick={() => {
                  setSelectedTab('propertyTax')
                  trackButtonClick({
                    eventName: "property_taxes_click",
                    eventCategory: "NEW-PDP",
                    eventSource: "on property tax section click",
                    eventLabel: `${propertyData?.propertyId} | ${
                      propertyData?.listingId
                    } | ${propertyData?.address?.streetNumber} ${
                      propertyData?.address?.streetName
                    }, ${propertyData?.address?.county}, ${
                      propertyData?.address?.city
                    }, ${propertyData?.address?.state}, ${
                      propertyData?.address?.zip
                    } | Referrer: Other|Foreclosure Property:${
                      isForeclosure ? "Yes" : "No"
                    } | Status:${propertyData?.commonAttributes?.status}`,
                  });
                }}
              >
                <img src={selectedTab === "propertyTax" ? propertyTaxActive : propertyTaxIcon} className="nav-tab-img" alt="" aria-hidden="true" />
                <span className="nav-tab-text">Property Taxes</span>
              </a>
            </li>
            )}


            {!shouldHidePriceHistory && (
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link localInfoBtn ${selectedTab === 'priceHistory' ? 'active' : ''}`}
                data-bs-toggle="tab"
                href="#priceHistory"
                role="tab"
                onClick={() => {
                  setSelectedTab('priceHistory')
                  trackButtonClick({
                    eventName: "price_history_click",
                    eventCategory: "NEW-PDP",
                    eventSource: "on price history section click",
                    eventLabel: `${propertyData?.propertyId}|${
                      propertyData?.listingId
                    }|${propertyData?.address?.streetNumber} ${
                      propertyData?.address?.streetName
                    }, ${propertyData?.address?.county}, ${
                      propertyData?.address?.city
                    }, ${propertyData?.address?.state}, ${
                      propertyData?.address?.zip
                    }|Referrer: Other|Foreclosure Property:${
                      isForeclosure ? "Yes" : "No"
                    }|Status:${propertyData?.commonAttributes?.status}`,
                  });
                }}
              >
                <img src={selectedTab === "priceHistory" ? priceHistoryActive : priceHistoryIcon} className="nav-tab-img"alt="" aria-hidden="true" />
                <span className="nav-tab-text">Price History</span>
              </a>
            </li>
            )}


            {propCategory === "COMMERCIAL" && (
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link localInfoBtn"
                  data-bs-toggle="tab"
                  href="#demographics"
                  role="tab"
                  onClick={() => {
                    setSelectedTab('demographics')
                    trackButtonClick({
                      eventName: "demographics_click",
                      eventCategory: "NEW-PDP",
                      eventSource: "on demographics section click",
                      eventLabel: `${propertyData?.propertyId} | ${
                        propertyData?.listingId
                      } | ${propertyData?.address?.streetNumber} ${
                        propertyData?.address?.streetName
                      }, ${propertyData?.address?.county}, ${
                        propertyData?.address?.city
                      }, ${propertyData?.address?.state}, ${
                        propertyData?.address?.zip
                      } | Referrer: Other|Foreclosure Property:${
                        isForeclosure ? "Yes" : "No"
                      } | Status:${propertyData?.commonAttributes?.status}`,
                    });
                  }}
                >
                  <span className="nav-tab-text pl0">Demographics</span>
                </a>
              </li>
            )}

        </ul>
        <div className="localInfoContainer">
          <div className="tab-content" id="myTabContent2">
            {!shouldHidePropertyTaxes && (
            <div
              className={`tab-pane fade ${selectedTab === 'propertyTax' ? 'show active' : ''}`}
              id="propertyTax"
              role="tabpanel"
            >
              {renderTax()}
            </div>
            )}
            {!shouldHidePriceHistory && (
            <div
              className={`tab-pane fade row pl15 pl0-1199 pr15 pr0-1199 ${selectedTab === 'priceHistory' ? 'show active' : ''}`}
              id="priceHistory"
              role="tabpanel"
            >
              {renderPriceHistory()}
            </div>
            )}
            <div
              className="tab-pane fade row "
              id="demographics"
              role="tabpanel"
            >
              <p className="demographic-text" tabIndex="0">{demographicInfo ? demographicInfo : "Not Available"}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocalInfo;
